import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { color, space, device, radius, H4, transition } from '@ticketswap/solar'
import { Close } from '@ticketswap/comets'
import { createMarkup } from '~/utils'
import AppStoreBadges from '../AppStoreBadges'

const Container = styled.div`
  position: relative;
  background-color: ${color.sunLightest};
  padding: ${space[16]};
  border-radius: ${radius.lg};

  @media ${device.tablet} {
    padding: ${space[24]};
  }
`

const Text = styled.p`
  margin-top: ${space[4]};
  margin-bottom: ${space[16]};

  @media ${device.tablet} {
    margin-top: ${space[8]};
  }
`

const CloseButton = styled.button`
  opacity: 0.4;
  position: absolute;
  right: ${space[16]};
  top: ${space[16]};
  transition: ${transition};

  &:hover,
  &:focus {
    opacity: 0.5;
  }
`

function AppsAdoptionAlert({
  title,
  text,
  onClose,
  trackingContext,
  ...props
}) {
  return (
    <Container {...props}>
      {title && <H4>{title}</H4>}
      {text && (
        <Text>
          <span
            dangerouslySetInnerHTML={createMarkup(text, { renderInline: true })}
          />
        </Text>
      )}
      <AppStoreBadges trackingContext={trackingContext} />
      {onClose && (
        <CloseButton onClick={onClose}>
          <Close size={24} />
        </CloseButton>
      )}
    </Container>
  )
}

AppsAdoptionAlert.propTypes = {
  trackingContext: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  onClose: PropTypes.func,
}

export default AppsAdoptionAlert
